<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <g clip-path="url(#a)">
    <path fill="#2AABEE" d="M12 0a11.999 11.999 0 0 0-8.484 20.485 11.999 11.999 0 1 0 16.968-16.97A11.999 11.999 0 0 0 12 0Z"/>
    <path fill="#fff" d="M5.432 11.873a584.334 584.334 0 0 1 6.997-3.014c3.334-1.386 4.026-1.627 4.478-1.635.1-.002.32.023.465.14.12.098.154.231.17.325.015.093.036.306.02.472-.18 1.898-.963 6.502-1.36 8.627-.167.9-.499 1.201-.82 1.23-.697.065-1.226-.46-1.9-.902-1.056-.693-1.653-1.123-2.678-1.8-1.185-.78-.417-1.209.258-1.91.177-.184 3.248-2.977 3.306-3.23.008-.032.015-.15-.056-.212-.07-.062-.173-.041-.248-.024-.107.024-1.792 1.139-5.062 3.345-.478.33-.911.49-1.301.481-.428-.01-1.253-.242-1.866-.441-.75-.245-1.348-.374-1.296-.789.027-.216.325-.437.893-.663Z"/>
  </g>
  <defs>
    <linearGradient id="b" x1="1200" x2="1200" y1="0" y2="2400" gradientUnits="userSpaceOnUse">
      <stop stop-color="#2AABEE"/>
      <stop offset="1" stop-color="#229ED9"/>
    </linearGradient>
    <clipPath id="a">
      <path fill="#fff" d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
